import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.25 12a9.75 9.75 0 1 0 19.5 0 9.75 9.75 0 0 0-19.5 0Zm1.795 7.955a11.25 11.25 0 1 1 15.91-15.91 11.25 11.25 0 0 1-15.91 15.91Z",
		fill: "#262626",
		fillRule: "evenodd",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M2.25%2012a9.75%209.75%200%201%200%2019.5%200%209.75%209.75%200%200%200-19.5%200Zm1.795%207.955a11.25%2011.25%200%201%201%2015.91-15.91%2011.25%2011.25%200%200%201-15.91%2015.91Z%22%20fill%3D%22%23262626%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
